import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingMessage = ({ children }) => (
  <span className="d-flex align-items-center">
    <Spinner size="sm" color="dark" className="mr-1" />{children}
  </span>
);

export default LoadingMessage;



// WEBPACK FOOTER //
// ./src/components/LoadingMessage.js